<template>
    <div>
        <div class="content-page">
            <!-- Start content -->
            <div class="content">
                <div class="container-fluid">
                    <div class="page-title-box">
                        <div class="row align-items-center">
                            <div class="col-sm-6">
                                <h4 class="page-title"><font color="white">Get Started</font></h4>
                            </div>
                        </div>
                    </div>

                    <!-- end row -->
                    <div class="row m-b-30">
                        <div class="col-12">
                            <div class="card-deck-wrapper">
                                <div class="card-deck">
                                    <div class="card">
                                        <div class="card-body">
                                            <h4 class="card-title font-16 mt-0 text-center"><i class="fas fa-atlas"></i> About iRecharge</h4>
                                            <p class="card-text">iRecharge is an internet powered distribution platform that enables users purchase virtual products and services such as airtime and mobile data, internet subscriptions, pay TV, and Bulk SMS</p>
                                        <p class="card-text">This solution which integrates seamlessly with all major Telecoms operators and service providers aims to provide value added services to consumers through as many access points as available.</p>
                                        <p class="card-text">With instant transaction fulfillment and no need for pins or print outs, it's a quick and easy solution for airtime and subscriptions.</p>
                                        <p class="card-text">Our Services and Solutions are designed to provide our customers with ultimate convenience…anywhere, anytime.</p>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-body">
                                            <h4 class="card-title font-16 mt-0 text-center"><i class="fas fa-chalkboard-teacher"></i> About iRecharge Merchant System</h4>
                                            <p class="card-text">iRecharge Merchant System is a service designed for iRecharge vendors to allow them have a raw sketch and full details about  their possible transactions, and know the possible Amount of their next Payout.</p>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-body">
                                            <h4 class="card-title font-16 mt-0 text-center"><i class="fas fa-truck"></i> Dashboard Tour</h4>
                                            <p class="card-text">See what you can do with iRecharge Merchant System.</p>
                                            <p class="card-text"><strong>Dashboard:</strong> Shows Overview of both your Transactions and your Next payout you have with iRechrge. </p>
                                            <p class="card-text"><strong>Transaction:</strong> Get detailed information about all successful, failed, or abandoned payments.</p>
                                       <p class="card-text"><strong>Payouts:</strong> See how much you’ve made on iRecharge over time.</p>
                                        <p class="card-text"><strong>Profile:</strong> Shows you details of your profile you filled during Vendor registration on irecharge website</p>
                                       
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- end row -->
                </div>
                <!-- container-fluid -->
            </div>
            <!-- content -->
        </div>
    </div>
</template>
<script>
export default {
    
}
</script>